var React = require('react');

function ToolIndesign (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-foreground"},[React.createElement("rect",{"x":"9.9","y":"9","width":"3.3","height":"17.5","key":0}),React.createElement("path",{"d":"M22.4,9v4.2c-0.1,0-0.3,0-0.8,0c-1,0-2.2,0.4-2.2,0.4s-3.9,1.4-3.9,6.3S19.3,27,22,27s4-1.3,4-1.3V9H22.4z M22.4,24\n      c0,0-3.9-0.1-3.9-4.1c0-4,3.9-4.1,3.9-4.1V24z","key":1})]));
}

ToolIndesign.defaultProps = {"version":"1.0","width":"36px","height":"36px","viewBox":"0 0 36 36","xmlSpace":"preserve"};

module.exports = ToolIndesign;

ToolIndesign.default = ToolIndesign;
